import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getRoutePath } from '@/routes/util';

/** Keeps bookmarked Troubleshooting Guide links working after the rename. */
export function LegacyTroubleshootingRedirect() {
  const {
    orgId = '',
    workspaceId = '',
    automationId = '',
    entryId,
  } = useParams();
  const { search, hash } = useLocation();
  const pathname = entryId
    ? getRoutePath('RESOLUTION_PLAYBOOK_ENTRY_DETAILS', {
        orgId,
        workspaceId,
        automationId,
        entryId,
      })
    : getRoutePath('RESOLUTION_PLAYBOOK', { orgId, workspaceId, automationId });

  return <Navigate to={{ pathname, search, hash }} replace />;
}
